import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { HideElementsConstants } from '../constants/hide-elements.constants';

@Directive({
    selector: '[appHideElement]',
    standalone: false
})
export class HideElementDirective implements OnInit {

  @Input() isHidden = false;

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit() {
    if (HideElementsConstants.HIDDEN_ELEMENT_FIRST_RELEASE) {
      if (!this.isHidden) {
        this.elementRef.nativeElement.style.display = 'none';
      } else {
        this.elementRef.nativeElement.setAttribute('style', 'visibility: hidden;');
      }
    }
  }

}
